import axios from 'axios';

// import { redirect2LoginPage } from "./redirectUri";
import { doCheckAndRestStorageInfo } from "./auth";
axios.defaults.timeout = 20000;

var instance = axios.create();

instance.interceptors.request.use(
    config => {
        doCheckAndRestStorageInfo();
        let token = sessionStorage.getItem('token');
        config.headers.common.Authorization = 'Bearer ' + token;
        config.headers.common.mainId = sessionStorage.getItem('_mainId');
        config.headers.common.uid = sessionStorage.getItem('_uid');
        if (sessionStorage.getItem('_mainId') == null || sessionStorage.getItem('_mainId') == '') {
            location.hash = "/";
        }
        // 处理 GET 请求带 body 的情况（某些接口需要）
        if (config.method === 'get' || config.method === 'GET') {
            if (config.data) {
                // 为 GET 请求设置 Content-Type
                config.headers['Content-Type'] = 'application/json';
                // 使用自定义 adapter 确保 GET 请求能够发送 body
                config.adapter = function(adapterConfig) {
                    return new Promise((resolve, reject) => {
                        const xhr = new XMLHttpRequest();
                        xhr.open('GET', adapterConfig.url, true);
                        
                        // 设置请求头
                        Object.keys(adapterConfig.headers || {}).forEach(key => {
                            if (key !== 'common' && adapterConfig.headers[key]) {
                                xhr.setRequestHeader(key, adapterConfig.headers[key]);
                            }
                        });
                        // 设置 common 中的头部
                        if (adapterConfig.headers && adapterConfig.headers.common) {
                            Object.keys(adapterConfig.headers.common).forEach(key => {
                                if (adapterConfig.headers.common[key]) {
                                    xhr.setRequestHeader(key, adapterConfig.headers.common[key]);
                                }
                            });
                        }
                        
                        xhr.onload = function() {
                            let responseData;
                            try {
                                responseData = JSON.parse(xhr.responseText || '{}');
                            } catch (e) {
                                responseData = xhr.responseText || {};
                            }
                            resolve({
                                data: responseData,
                                status: xhr.status,
                                statusText: xhr.statusText,
                                headers: {},
                                config: adapterConfig
                            });
                        };
                        
                        xhr.onerror = function() {
                            reject(new Error('Network Error'));
                        };
                        
                        xhr.ontimeout = function() {
                            reject(new Error('Request Timeout'));
                        };
                        
                        xhr.timeout = adapterConfig.timeout || 20000;
                        
                        // 发送 body
                        if (adapterConfig.data) {
                            xhr.send(JSON.stringify(adapterConfig.data));
                        } else {
                            xhr.send();
                        }
                    });
                };
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//axios response 拦截器
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (!error.response) {
            return Promise.reject(error);
        }

        if (error.response.status === 403 || error.response.code == '5000') {
            // alert(JSON.stringify(error))
            // redirect2LoginPage();
        } else if (error.response.status == 510) {
            console.log("============== exe 510 action",window.location.href);
            location.href = process.env.VUE_APP_EXPIRED_URL;
        } else {
            return Promise.reject(error)
        }
    }
);

export default instance;
